<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <span class="back" @click="$router.go(-1)"
                ><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span
            >
            <div class="wrap">
                <div class="content">
                    <h5 class="page-title">
                        <span class="blue title-line"></span> 手机号认证
                    </h5>
                    <div class="main-box">
                        <p class="warning">
                            <i class="el-icon-warning"></i>
                            &nbsp;&nbsp;&nbsp;&nbsp;请务必提供真实信息，公司有权自行或委托第三方，审查提供的身份信息是否真实、有效。若提供虚假信息，由此带来的后果由提供方承担。
                        </p>
                        <div class="form">
                            <el-form
                                :model="applyForm"
                                ref="applyForm"
                                label-width="100px"
                                class="demo-ruleForm"
                            >
                                <el-form-item
                                    label="真实姓名:"
                                    label-width="130px"
                                    prop="name"
                                >
                                    <el-input
                                        disabled
                                        v-model="applyForm.name"
                                        placeholder="请输入您的真实姓名"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="证件号码:"
                                    label-width="130px"
                                    prop="idCard"
                                    v-if="idCardShow"
                                >
                                    <el-input
                                        disabled
                                        v-model="applyForm.idCard"
                                        placeholder="请输入您的身份证号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    label="证件号码:"
                                    label-width="130px"
                                    prop="idCardHidden"
                                >
                                    <el-input
                                        disabled
                                        v-model="applyForm.idCardHidden"
                                        placeholder="请输入您的身份证号"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="手机号码:"
                                    label-width="130px"
                                    prop="phone"
                                >
                                    <el-input
                                        disabled
                                        v-model="applyForm.phone"
                                        placeholder="请输入您的手机号码"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item class="btns">
                                    <span @click="submit('applyForm')"
                                        >提交认证</span
                                    >
                                    <b @click="cancel">取消</b>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-row>
</template>

<script>
import {phoneAuthApprove} from '@http/user_center/realName'
export default {
    data() {
        return {
            idCardShow:true,
            applyForm: {
                phone: '',
                type:1,
            },
        };
    },

    components: {},

    computed: {},

    created() {
        if(JSON.parse(sessionStorage.getItem('pesonalInfo'))){
            let{idCard,idCardHidden,legalName,phone}=JSON.parse(sessionStorage.getItem('pesonalInfo'));
            if(idCardHidden){
                // 显示加密身份证信息disable状态
                this.idCardShow=false;
            }else{
                //显示身份证输入框，手动输入
                this.idCardShow=true;
            }
            this.applyForm.name=legalName;
            this.applyForm.idCardHidden=idCardHidden;
            this.applyForm.idCard=idCard;
            this.applyForm.type=1;
            this.applyForm.phone=phone;
        }else{
            this.$router.replace({
                path:'/userCenter/realName/personalInfo'
            })
        }
    },

    mounted() {},

    methods: {
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var that = this;
                    let clientId = this.$getlocalStorage("queryData")
                        ? this.$getlocalStorage("queryData").clientId
                        : "";
                    if (clientId) {
                        this.applyForm = Object.assign({}, this.applyForm, {
                            clientId,
                        });
                    }
                    this.$TsaWebTrace.post({
                        data: {
                            "eventId": 35025,
                            "logParam":{
                                'phone':that.applyForm.phone,
                                'userName':that.applyForm.name,
                                'idCard':that.applyForm.idCard,
                            }
                        },
                    });
                    phoneAuthApprove(this.applyForm).then(()=>{
                        that.$msg('企业法人实名认证成功','success')
                        that.$store.dispatch('userInfo/setLawyerInfo', {})

                        setTimeout(()=>{
                            that.$router.replace({
                                path: '/userCenter/realName/enterpriseSign',
                            })
                        },3000)
                    })
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        cancel() {
            this.$router.replace({
                path: "/userCenter/realName/authenticationMode",
            });
        },
    },
};
</script>
<style src="../../../assets/css/content.css" scoped></style>
<style scoped lang="less">
.mianContent{
    position: relative;
    .back{
        position:absolute;
        right: 30px;
        top:-30px;
        font-size: 14px;
        cursor: pointer;
        &:hover{
            color:#10A0E9
        }
    }
}
.warning {
    font-size: 14px;
}
.main-box {
    text-align: center;
}
.form {
    width: 40%;

    margin: 30px auto;
}
.page-title{
    display: flex;
    align-items: center;
}
.form .el-form-item {
}
.yzm-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.yzm-item .el-form-item {
    width: 400px;
}
.yzm-item span {
    width: 130px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    background: #fff;
    color: #3f7df7;
    cursor: pointer;
    border: 1px solid #3f7df7;
    font-size: 14px;
    margin-left: 10px;
    box-sizing: border-box;
    margin-top: 3px;
}
.yzm-item span:hover {
    background: #3f7df7;
    color: #fff;
}
.yzm-item span[disabled] {
    color: #fff;
    background: #bcbcbc;
    pointer-events: none;
    cursor: inherit;
    border-color: #bcbcbc;
}
.btns {
    text-align: left;
    margin-top: 50px;
}
.btns span {
    display: inline-block;
    text-align: center;
    width: 148px;
    height: 40px;
    line-height: 40px;
    color: #3080fe;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid #3080fe;
}
.btns b {
    margin-left: 30px;
    display: inline-block;
    text-align: center;
    width: 148px;
    height: 40px;
    line-height: 40px;
    color: #999;
    cursor: pointer;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid #ccc;
}
.btns b:hover {
    color: #333;
    background: #f5f5f5;
}
.btns span:hover {
    background: #3080fe;
    color: #fff;
}
@media screen and (max-width:1500px) {
    .btns{
        span,b{
            width:120px;
        }
    }
    
}
</style>

